import { AfterViewInit, ElementRef, Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../../../../app/shared/_services/storage.service';
import { SwiperOptions } from 'swiper';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { CarrelloService } from '../../../../../app/shared/_services/carrello.service';
import { AlertService } from '../../../../../app/shared/_services/alert.service.';
declare var carousel: any;

@Component({
  selector: 'app-blocco-schede',
  templateUrl: './blocco-schede.component.html',
  styles: []
})
export class BloccoSchedeComponent implements OnInit {

  constructor(
    private carrelloService: CarrelloService,
    private router: Router,
    private localize: LocalizeRouterService,
    private alertService: AlertService
    ) { }

  @Input() campi;
  swiper;

  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination', clickable: true },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      // when window width is >= 576px
      576: {
        slidesPerView: 2,
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 3,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 4,
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 5,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next-stem',
      prevEl: '.swiper-button-prev-stem'
    },
    spaceBetween: 30
  };


  ngOnInit() {
  }

  aggiungiAlCarrello(scheda) {
    this.carrelloService.salvaProdotto({
      idScheda: scheda.idScheda,
      idPercorso: 0,
      quantita: 1
    }).subscribe(() => this.alertService.apriAlert.emit('ARTICOLO_AGGIUNTO_AL_CARRELLO'));
  }

}
